import Markdown from "react-markdown";
import { host } from "@/config";
type Props = {
  children: string;
  skipParagraph?: boolean;
};
const MarkDown = ({
  skipParagraph = false,
  children,
  ...props
}: Props) => {
  return <Markdown components={{
    p: ({
      ...props_0
    }) => skipParagraph ? <>{props_0.children}</> : <p>{props_0.children}</p>,
    u: ({
      ...props_1
    }) => <u>{props_1.children}</u>,
    a: ({
      children: children_0,
      ...props_2
    }) => {
      try {
        const url = new URL(props_2.href ?? "", host);
        if (url.origin !== host) {
          props_2.target = "_blank";
          props_2.rel = "noopener noreferrer";
        }
        return <a {...props_2}>{children_0}</a>;
      } catch {
        return <>{children_0}</>;
      }
    }
  }} {...props}>
      {children}
    </Markdown>;
};
export default MarkDown;